import { useRouterState } from "@tanstack/react-router";

/**
 * The pathname of the page on screen, not the one loading. Shell chrome keyed
 * on `useLocation` switches 30-50ms before the page does.
 */
export const useResolvedPathname = (): string =>
  useRouterState({
    select: (s) => (s.resolvedLocation ?? s.location).pathname,
  });
